module.exports = __webpack_public_path__ + "static/media/question_bg.6c68f51d.jpg";